import { Component,  HostBinding, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss']
})
export class MenuItemComponent implements OnInit {
  @Input() iconSrc: string;
  @Input() name: string;
  @Input() class: string;
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/www/onetouchSuperAdmin/src/app/core/menu/menu-item/menu-item.component.ts